import type { ReactElement, ReactNode } from "react";
import { Tab as MuiTab, Tabs as MuiTabs } from "@mui/material";
import "@/shared/components/generic/tabs/Tabs.scss";

interface TabsProperties {
  labels: ReactNode[];
  selectedIndex: number;
  onIndexChange: (newIndex: number) => void;
}

export default function Tabs(props: TabsProperties): ReactElement {
  return (
    <MuiTabs
      centered
      value={props.selectedIndex}
      onChange={(_, index: number) => {
        props.onIndexChange(index);
      }}
      className="mui-tabs"
      slotProps={{ indicator: { className: "MuiTabs-indicator" } }}
    >
      {props.labels.map((item, index) => (
        <MuiTab
          key={index}
          value={index}
          label={item}
          className={`MuiTab-root ${props.selectedIndex === index ? "Mui-selected" : ""}`}
        />
      ))}
    </MuiTabs>
  );
}
